import React from 'react';
import { scoreResult, SCORE_RESULT_NAMES } from '../utils/scoreResult';
import './ScoreMarker.css';

/**
 * One hole's score, in the shape its result earns — the ONE marker the
 * leaderboard's hole-by-hole card and the finalise scorecard both draw, so the
 * same round can never look different on the two pages. Which marker is
 * `scoreResult`'s answer; the drawing is ScoreMarker.css.
 *
 * Labelled for assistive tech ("5, double bogey or worse"), because the shape
 * that tells a sighted player what the hole was says nothing to a screen reader.
 */
const ScoreMarker = ({ strokes, par, className = '' }) => {
  const n = parseInt(strokes, 10);
  const played = Number.isFinite(n) && n > 0;
  const result = played ? scoreResult(n, par) : null;
  const kind = played ? (result || 'none') : 'empty';
  const label = !played
    ? 'Not played'
    : result ? `${n}, ${SCORE_RESULT_NAMES[result]}` : String(n);

  return (
    <span
      className={`sc-marker sc-marker--${kind}${className ? ` ${className}` : ''}`}
      role="img"
      aria-label={label}
    >
      {played ? n : '-'}
    </span>
  );
};

export default React.memo(ScoreMarker);
